module.exports = __webpack_public_path__ + "img/bundle_mapping.6a80419e.svg";